import { render, staticRenderFns } from "./DocuTaskEntryList.vue?vue&type=template&id=e4b96080&scoped=true&"
import script from "./DocuTaskEntryList.vue?vue&type=script&lang=js&"
export * from "./DocuTaskEntryList.vue?vue&type=script&lang=js&"
import style0 from "./DocuTaskEntryList.vue?vue&type=style&index=0&id=e4b96080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b96080",
  null
  
)

export default component.exports